import type {
    IGetProcessQuestionnaireResponseQuery,
    IProcessQuestionnaireResponse,
} from '@common/interfaces/api/processQuestionnaireResponsesApi';
import { fetchJson } from '@frontend/store/fetch';
import { getUrlQueryParameters } from './queryParameterUtils';

const baseUrl = '/api/processQuestionnaireResponses';

export async function getProcessQuestionnaireResponse(
    processQuestionnaireResponseId: string,
    query: IGetProcessQuestionnaireResponseQuery | undefined,
    signal: AbortSignal
): Promise<IProcessQuestionnaireResponse> {
    const url = getUrlQueryParameters<IGetProcessQuestionnaireResponseQuery>(
        `${baseUrl}/${processQuestionnaireResponseId}`,
        query
    );

    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}
